import React, { useCallback } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SegmentUiElements } from '@foxcorp/delta-web-analytics';
import { LAST_SESSION_PATH } from 'helpers/RouteHelper';
import { noop } from 'helpers/GlobalHelper';
import { setSessionStorageItem } from 'helpers/Storage';
import { titleProcessor } from '../../../helpers/processorHelper';
import Style from '../../../Styles/SeeAllTile.module.scss';

const SeeAllTile = props => {
  const {
    account,
    gridIndex,
    gridTitle,
    itemIndex,
    link,
    name,
    network,
    onTileClick,
    onTitleClick,
    onTileMouseDown,
    originalItem,
    percentWatched,
    recommendationIdData,
    scaleFromLeft,
    scaleFromRight,
    subtitleText,
    theme,
    titleLink,
  } = props;
  const titleLinkVal = titleLink || link;
  const imageContainerClasses = [Style.imageContainer, Style.maintainAspectRatio];
  if (scaleFromLeft) imageContainerClasses.push(Style.scaleFromLeft);
  if (scaleFromRight) imageContainerClasses.push(Style.scaleFromRight);
  const { target, title, titleText } = titleProcessor(props);
  const onTileTitleClick = useCallback(() => {
    setSessionStorageItem({ key: LAST_SESSION_PATH, value: window.location.pathname });
    onTileClick({ uiElement: SegmentUiElements.SERIES_EPISODE });
    if (onTitleClick) {
      onTitleClick({
        account,
        gridIndex,
        gridTitle,
        itemIndex,
        name,
        network,
        originalItem,
        percentWatched,
        recommendationIdData,
        subtitleText,
        title,
        titleText,
        uiElement: SegmentUiElements.SERIES_TITLE,
      });
    }
  }, [
    account,
    gridIndex,
    gridTitle,
    itemIndex,
    name,
    network,
    onTileClick,
    onTitleClick,
    originalItem,
    percentWatched,
    recommendationIdData,
    subtitleText,
    title,
    titleText,
  ]);

  return (
    <Link
      className={(theme.tile, Style.tile)}
      onClick={onTileTitleClick}
      onMouseDown={onTileMouseDown}
      to={titleLinkVal}
      target={target}
    >
      <div className={classNames(imageContainerClasses)} onClick={onTileTitleClick}>
        <div className={Style.content}>{title}</div>
      </div>
    </Link>
  );
};

export default SeeAllTile;

SeeAllTile.propTypes = {
  account: PropTypes.shape({}),
  gridIndex: PropTypes.number,
  gridTitle: PropTypes.string,
  itemIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  link: PropTypes.string,
  name: PropTypes.string,
  network: PropTypes.string,
  onTileClick: PropTypes.func,
  onTitleClick: PropTypes.func,
  onTileMouseDown: PropTypes.func,
  originalItem: PropTypes.shape({}),
  percentWatched: PropTypes.number,
  recommendationIdData: PropTypes.oneOfType([PropTypes.node, PropTypes.shape({})]),
  scaleFromLeft: PropTypes.bool,
  scaleFromRight: PropTypes.bool,
  subtitleText: PropTypes.string,
  theme: PropTypes.shape({}).isRequired,
  titleLink: PropTypes.string,
};

SeeAllTile.defaultProps = {
  account: {},
  gridIndex: null,
  gridTitle: null,
  itemIndex: null,
  link: null,
  name: null,
  network: null,
  onTileClick: noop,
  onTitleClick: noop,
  onTileMouseDown: noop,
  originalItem: null,
  percentWatched: null,
  recommendationIdData: null,
  scaleFromLeft: false,
  scaleFromRight: false,
  subtitleText: null,
  titleLink: null,
};
